import { CheckBoxOutlineBlank } from '@mui/icons-material';
import {
  Box,
  Checkbox,
  CheckboxProps,
  Typography,
  useTheme,
} from '@mui/material';

import { CheckBoxIcon } from './components';

type CheckboxButtonProps = {
  label: string;
  checked?: boolean;
  onChange: () => void;
} & CheckboxProps;

export const CheckboxButton = ({
  label,
  checked,
  onChange,
  ...props
}: CheckboxButtonProps) => {
  const { palette } = useTheme();

  return (
    <Box
      sx={{
        borderRadius: 2,
        width: '100%',
        height: 44,
        background: checked ? palette.gradients.primary2 : palette.grey50,
        color: checked ? 'text.contrast' : 'text.main',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}
      onClick={onChange}>
      <Checkbox
        disableRipple
        sx={{
          '&:hover': {
            backgroundColor: 'transparent',
          },
        }}
        color="default"
        icon={<CheckBoxOutlineBlank sx={styles.icon} />}
        checkedIcon={<CheckBoxIcon sx={styles.icon} />}
        checked={checked}
        onChange={onChange}
        {...props}
      />
      <Typography
        variant="body2"
        sx={{ color: checked ? 'text.contrast' : 'text.main' }}>
        {label}
      </Typography>
    </Box>
  );
};

const styles = {
  icon: {
    width: 16,
    height: 16,
    backgroundColor: 'surface.background',
    color: 'white',
    borderRadius: 1,
    border: 1,
    borderColor: 'text.main',
  },
};
